import { api } from './api';

/**
 * Read-only mirror of app/src/services/itemDefaultSettingsApi.ts. This portal
 * consumes the tenant's item defaults but does not configure them —
 * configuration lives in the app portal's Admin mode
 * (Settings -> Item Defaults).
 */
export interface ItemDefaultSettingsDTO {
  defaultUnitId: string | null;
  defaultGstRateId: string | null;
  autoSalesPriceEnabled: boolean;
  /** Markup on cost, as a percentage: sales = purchase * (1 + p / 100). */
  defaultProfitPercent: number;
}

export const ITEM_DEFAULTS_EFFECTIVE_KEY = ['item-defaults', 'effective'] as const;

export const itemDefaultSettingsApi = {
  /** Resolved defaults for the caller's own branch (branch comes from the token). */
  getEffective: async (): Promise<ItemDefaultSettingsDTO> => {
    const response = await api.get('/item-defaults/effective');
    return response.data.data;
  },
};
